/**
 * Design tokens for the Nemo Prototypes Studio shell (dark theme).
 * Used by PrototypeStudioLayout and all Home page components.
 * Matches the HeroSection gradient palette (#0f172a → #1e293b → #1e3a5f).
 */
export const S = {
  // Backgrounds
  bgDeep:       '#0f172a',  // page body
  bg:           '#1e293b',  // header, footer, sidebar, panels
  bgElevated:   '#263348',  // slightly lighter surface (hover rows, section headers)
  bgHover:      'rgba(255,255,255,0.06)',
  bgSubtle:     'rgba(255,255,255,0.03)',

  // Borders
  border:       'rgba(255,255,255,0.08)',
  borderStrong: 'rgba(255,255,255,0.14)',

  // Text
  textPrimary:  '#e2e8f0',
  textMuted:    '#94a3b8',
  textDim:      '#475569',

  // Accent — indigo
  accent:       '#6366f1',
  accentText:   '#a5b4fc',
  accentHover:  'rgba(99,102,241,0.18)',
  accentActive: 'rgba(99,102,241,0.85)',
  accentBadge:  'rgba(99,102,241,0.25)',

  // Status colors (used in stats + badges)
  green:        '#34d399',
  blue:         '#60a5fa',
  slate:        '#94a3b8',
};
